// ----------------------------
// Created by Bulletproof Games
//            2021
//  www.bulletproofgames.co.uk
// ----------------------------
//
// Game Controller
//
// The game controller tracks and looks after the current game state, and orchestrates components
// ----------------------------

gameController = {};
gameController.autoMode = false;
gameController.firstGamePlayed = false;
gameController.dynamicSpinner = true;
gameController.inFreeSpins = false;
gameController.cyclingWins = false;
gameController.spinComplete = false;
gameController.bonusSymbolsLanded = 0;
gameController.minBonusForFeature = 3; //should be data driven
gameController.bonusWWSymbolsLanded = 0;
gameController.minWWBonusForFeature = 3; //should be data driven
gameController.canSlamStop = false;
gameController.slamStopped = false;
gameController.preFSReelPrize = 0;
gameController.inBuyABonusNormal = false;
gameController.inBuyABonusExtra = false;
gameController.anticipationOn = false;
gameController.justHadFreeSpins = false;
gameController.soundTimerInactivity = undefined;
gameController.soundsFadeTimer = undefined;
gameController.spinTuneId = undefined;
gameController.idleTuneId = undefined;
gameController.stoppedReels = [false, false, false, false, false];
gameController.landedReels = [false, false, false, false, false];
gameController.inShuffle = false;
gameController.shuffleLastSpin = false;
gameController.spinThemePlaying = false;
gameController.idleThemePlaying = false;
gameController.shuffleOutroTuneId = undefined;
gameController.gameReplaying = false;
gameController.bigWin = undefined;
gameController.currentMultiplier = 1;
gameController.spinHasWin = false;
gameController.totalWinnings = 0;
gameController.mysteryData = undefined;
gameController.winlinesCancelled = false;
gameController.idle = true;
gameController.gameRecovering = false;
gameController.currentNonBABStake = 0;
gameController.currentStake = 0;
gameController.shuffleStake = 0;

// Persistence stake change tracking
gameController.stakeSnapshots = {};
gameController.previousStake = undefined;
gameController.previousMode = undefined;

gameController.xSymbolPositionOffset = { x: 40, y: 40 };
gameController.xSymbolScale = 0.5;

gameController.lastTotalLineWinnings = 0;

gameController.reelSpinSound = undefined;

gameController.cycleWinTimer = undefined;

gameController.globalHelperGetStake = function () {
  let stakeController = resourceManager.getController('stakeController');
  let stake = stakeController.BaseStake;
  if (gameController.inBuyABonusNormal || gameController.inBuyABonusExtra) {
    if (gameController.inBuyABonusNormal) {
      stake = gameController.currentStake * 50;
    } else {
      stake = gameController.currentStake * 100;
    }
  }
  return stake;
};

gameController.initialise = function () {
  // Hide side menu highlight
  resourceManager.get('uiContainer:bg:sideMenu:glow').visible = false;
  resourceManager.get('buttonContainerMobile:reflexButtonBar:sideMenu_portrait:glow').visible = false;

  gameController._bigWin = resourceManager.get('bigWin');
  gameController._bigWin.init();
  gameController.goldenBetButton = resourceManager.get('goldenBetToggleButton');

  gameController.bigWin = resourceManager.get('bigWin');

  gameController.slotMachine = resourceManager.getController('SlotMachine');
  const reelNames = ['reel0', 'reel1', 'reel2', 'reel3', 'reel4'];
  gameController.slotMachine.subscribeToReelsLandedEvent(function (reelId) {
    const reel = reelNames.indexOf(reelId);
    resourceManager.get(`slotContainer:reelContainer:SymbolAnimator`).visible = true;

    gameController.stoppedReels[reel] = true;
    if (gameController.slamStopped && gameController.reelsToSlam.length > 0) {
      let allStopped = true;
      let i = 0;
      for (i; i < gameController.reelsToSlam.length; ++i) {
        const slammedReel = gameController.reelsToSlam[i];
        if (!gameController.stoppedReels[slammedReel]) {
          allStopped = false;
          break;
        }
      }
      if (allStopped) {
        gameController.reelsToSlam = [];
        let i = 0;
        for (i; i < gameController.stoppedReels.length; ++i) {
          if (gameController.stoppedReels[i]) {
            console.log('sending spinLand for reel: ' + i);
            if (!gameController.landedReels[i]) {
              gameController.onSpinLand(i);
            }
          }
        }
      }
    } else {
      gameController.onSpinLand(reel);
    }
  });
  gameController.slotMachine.subscribeToReelsHitEvent(function (reelId) {
    const reel = reelNames.indexOf(reelId);
    gameController.playLandSounds(reel, gameController.slamStopped);
    gameController.onSpinHit(reel);
  });
  for (let i = 0; i < 5; ++i) {
    let rv = resourceManager.get('slotContainer:reelContainer:reel' + i);

    rv.reassignSlotMachine(gameController.slotMachine);
  }

  gameController.slotMachine.selectReelMode('default');

  gameController.winlineAnimator = resourceManager.getSharedPlugin('GameWinlineCatMullRomAnimatorEx');

  gameController.originalStopDistances = gameController.slotMachine._currentMode.stopDistances;

  gameController.winningsContainer = resourceManager.get('winningsContainer');

  gameController.winControllerMain = resourceManager.getController('WinControllerMain');

  gameController.symbolAnimator = resourceManager.get('slotContainer:reelContainer:SymbolAnimator');

  gameController.shuffler = resourceManager.get('shuffler');
  gameController.multiplierTrail = resourceManager.get('multiplierTrailWrapper:multiplierTrail:multiplierTrail');

  gameController.winlineDisplay = resourceManager.get('slotContainer:winlineDisplay:winlineDisplay');
  gameController.backgroundSymAnim = resourceManager.get(
    'slotContainer:reelContainer:symBackgroundAnimContainer:symBackgroundAnimDisplay'
  );

  gameController.logoAnim = resourceManager.get('gameTitleAnim');

  // winline highlight sounds
  gameController.winlineHighlightSounds = ['line_win_hilight_v1', 'line_win_hilight_v2', 'line_win_hilight_v3'];

  // win < 3x stake
  gameController.winlineSoundsLow = ['win_summary_v1', 'win_summary_v2', 'win_summary_v3'];
  // win > 3x and < 5x stake
  gameController.winlineSoundsMed = ['win_summary_med_v1', 'win_summary_med_v2', 'win_summary_med_v3'];
  // win > 5x stake
  gameController.winlineSoundsHi = ['win_summary_hi_v1', 'win_summary_hi_v2', 'win_summary_hi_v3'];

  gameController.slotMachine.setDynamicSpinner(true);
  gameController.slotMachine.setInjectorMode('main');

  gameController.onOrientationChange();
};

gameController.gameFullyLoaded = function (task) {
  gameController.powerBarDisplay = resourceManager.get('powerBarDisplay:powerBarDisplay');
  gameController.orbDisplay = resourceManager.get('orbDisplay:orbDisplay');
  gameController.overlayDisplay = resourceManager.get('overlayDisplay');
};

gameController.playLandSounds = function (reel, hasSlamStopped) {
  if (hasSlamStopped && reel !== 4) {
    return;
  }
  soundManager.play('reelstop' + reel);
  let bonusPossible = gameController.isBonusPossible(reel);
  const bonusOnReel = gameController.countBonusOnReel(reel);
  gameController.bonusSymbolsLanded += bonusOnReel;
  let bonusWWPossible = gameController.isWWBonusPossible(reel);
  const bonusWWOnReel = gameController.countWWBonusOnReel(reel);
  gameController.bonusWWSymbolsLanded += bonusWWOnReel;

  if (bonusPossible && reel === 3 && gameController.bonusSymbolsLanded < 2) {
    bonusPossible = false;
  }

  if (bonusWWPossible && reel === 3 && gameController.bonusWWSymbolsLanded < 2) {
    bonusWWPossible = false;
  }

  if (bonusOnReel > 0 && bonusPossible) {
    // soundManager.play('bonusland' + (gameController.bonusSymbolsLanded - 1));
  }
};

gameController.start = function () {
  gameController.stateMachine.switchState('WAITING_FOR_START');
};

gameController.shuffle = function (array) {
  var currentIndex = array.length,
    temporaryValue,
    randomIndex;

  // While there remain elements to shuffle...
  while (0 !== currentIndex) {
    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;

    // And swap it with the current element.
    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }

  return array;
};

gameController.onSpinComplete = function () {
  gameController.spinComplete = true;
  gameController.firstGamePlayed = true;

  soundManager.stop('reelspin');

  gameController.setState_WaitingForServer(gameController.spinTask);

  // if (gdk.serverParser._inReplayMode) {
  //   resourceManager.getController('inputOverlord').setState('disabled');
  // }
};

gameController.animateFSSpinSymbolLand = function (reel) {};

gameController.animateFSSpinSymbolWin = function (reel, callback) {};

gameController.isBonusThisSpin = function () {
  let bonusCount = 0;
  for (let i = 0; i < gameData.numReels; i++) {
    bonusCount += gameController.countBonusOnReel(i);
  }
  return bonusCount >= gameController.minBonusForFeature;
};

gameController.isBonusPossible = function (reel) {
  const numReelsLeft = gameData.numReels - 1 - reel;
  return reel < 2 || gameController.bonusSymbolsLanded + numReelsLeft >= gameController.minBonusForFeature;
};

gameController.isWWBonusPossible = function (reel) {
  const numReelsLeft = gameData.numReels - 1 - reel;
  return reel < 2 || gameController.bonusWWSymbolsLanded + numReelsLeft >= gameController.minWWBonusForFeature;
};

gameController.countSymbolOnReel = function (reel, symbolString) {
  let reelSymbols = [];
  if (gameController.spinTask.data.resultsPanel !== undefined) {
    reelSymbols = gameController.spinTask.data.resultsPanel.reelList[reel].symbols;
  }
  if (gameController.spinTask.data.resultPanel !== undefined) {
    reelSymbols = gameController.spinTask.data.resultPanel.reelList[reel].symbols;
  }

  const symbols = resourceManager.getConfiguration().symbols;
  const found = reelSymbols.find(function (symbol) {
    return symbol.value === symbols[symbolString].ID;
  });

  if (found !== undefined) {
    return 1;
  } else {
    return 0;
  }
};

gameController.countBonusOnReel = function (reel) {
  return 0;
};

gameController.countWWBonusOnReel = function (reel) {
  return 0;
};

gameController.onSpinHit = function (reel) {
  gameController.orbDisplay.reelLanded(reel);
  gameController.overlayDisplay.onSpinHit();
};

gameController.onSpinLand = function (reel) {
  if (reel === 4) {
    // gameController.reelSpinSound = soundManager.stop('soa_reelspin_v1');
  }
  if (!gameController.inFreeSpins) {
    const bonusPossible = gameController.isBonusPossible(reel);
    const fsBonusImminent = gameController.bonusSymbolsLanded >= gameController.minBonusForFeature - 1 && bonusPossible;
    const bonusWWPossible = gameController.isWWBonusPossible(reel);
    const wwBonusImminent =
      gameController.bonusWWSymbolsLanded >= gameController.minWWBonusForFeature - 1 && bonusWWPossible;

    if ((wwBonusImminent || fsBonusImminent) && reel < gameData.numReels - 1) {
      // soundManager.stop('hbc_anticipation_v2');
      // soundManager.play('hbc_anticipation_v2');

      gameController.canSlamStop = false;
    }

    if ((!bonusWWPossible && !bonusPossible) || reel === gameData.numReels - 1) {
      // soundManager.stop('hbc_anticipation_v2');
    }
  }
  gameData.reelsSpinning--;
  if (!gameController.inFreeSpins) {
    if (gameData.reelsSpinning === 0) {
      // soundManager.stop('hbc_anticipation_v2');
    }
  }
};

gameController.doSpin = function (spinTask) {
  gameController.hideStakeChangePersistenceMessage();
  gameController.winSkipped = false;
  gameController.symbolAnimator.skip();
  gameController.symbolAnimator.cleanUp();

  gameController.idle = false;
  gameController.setLogoIdle(false);

  timerManager.stop(gameController.cycleWinTimer);
  timerManager.stop(gameController.cycleWinsDelayTimer);
  gameController.slotMachine.dimAllSymbols(false, 0);
  // Update autoplay button text
  if (resourceManager.getController('autoplayController').Enabled) {
    resourceManager
      .getController('inputOverlord')
      .setText('autoplayCancelButton', String(autoplayManager.getRemainingRounds()));
    resourceManager
      .getController('inputOverlord')
      .setText('autoplayCancelButton_portrait', String(autoplayManager.getRemainingRounds()));
  }

  gameController.spinHasWin = spinTask.data.totalWinnings;
  gameController.totalWinnings = spinTask.data.totalWinnings;

  gameController.stateMachine.switchState('SPIN_REELS_SPINNING');

  gameData.reelsSpinning = gameData.numReels;
  gameController.promotionActive = spinTask.data.isPrePaidGame;

  let symbolsInfo = resourceManager.getConfiguration().symbols;

  let bonusSymbolCount = 0;
  let bonusWWSymbolCount = 0;
  gameController.longSpinReels = [false, false, false, false, false];
  // Set up data for the reels
  let symbols = [];
  let above = [];
  let below = [];
  for (let reel = 0; reel < spinTask.data.resultPanel.reelList.length; reel++) {
    symbols.push([]);
    above.push([]);
    below.push([]);
    for (let row = 0; row < spinTask.data.resultPanel.reelList[reel].symbols.length; row++) {
      symbols[reel].push(spinTask.data.resultPanel.reelList[reel].symbols[row].value);

      if (
        (bonusSymbolCount >= gameController.minBonusForFeature - 1 ||
          bonusWWSymbolCount >= gameController.minWWBonusForFeature - 1) &&
        reel < gameData.numReels
      ) {
        gameController.longSpinReels[reel + 1] = true;
      }
    }
    if (spinTask.data.resultPanel.symbolsAbove) {
      for (let row = 0; row < spinTask.data.resultPanel.symbolsAbove[reel].symbols.length; row++) {
        above[reel].push(spinTask.data.resultPanel.symbolsAbove[reel].symbols[row].value);
      }
    }
    if (spinTask.data.resultPanel.symbolsBelow) {
      for (let row = 0; row < spinTask.data.resultPanel.symbolsBelow[reel].symbols.length; row++) {
        below[reel].push(spinTask.data.resultPanel.symbolsBelow[reel].symbols[row].value);
      }
    }
  }

  gameController.slotMachine._currentMode.stopDistances = gameController.originalStopDistances;
  let newStopDistances = [];
  for (let r = 0; r < gameController.longSpinReels.length; ++r) {
    newStopDistances.push(gameController.originalStopDistances[r]);
    if (gameController.longSpinReels[r]) {
      newStopDistances[r - 1] += 50;
    }
  }
  gameController.slotMachine._currentMode.stopDistances = newStopDistances;
  spinController.stopSpin(symbols, above, below, gameController.onSpinComplete);

  gameData.spinData = spinTask.data;
  gameController.spinTask = spinTask;
  gameController.spinTask.join();
  timerManager.stop(gameController.soundTimerInactivity);

  let litOrbs = spinTask.data.powerSpheres.spheres;
  let orbCount = 0;
  for (let i = 0; i < litOrbs.length; i++) {
    if (litOrbs[i].lit) {
      orbCount++;
    }
  }
  for (let i = 0; i < litOrbs.length; i++) {
    if (orbCount > i) {
      litOrbs[i].lit = true;
    } else {
      litOrbs[i].lit = false;
    }
  }
  gameController.orbDisplay.setOrbStatus(litOrbs);
};

gameController.initNewSpin = function () {
  // Hide any visible mystery shutter animations immediately
  gameController.symbolAnimator.skip();
  gameController.symbolAnimator.cleanUp();
  //gameController.backgroundSymAnim.stopAnims();

  if (gameController.overlayDisplay) {
    gameController.overlayDisplay.hideOnSpin();
  }

  musicManager.onGameStart();

  // gameController.reelSpinSound = soundManager.play('soa_reelspin_v1');
  gameData.winningsText.skip();
  gameController.totalWinnings = 0;
  //We need to reset the positions of the top and bottom symbols in case there was a super wild there previously
  for (let i = 0; i < 5; i++) {
    resourceManager.get(`slotContainer:reelContainer:reel${i}:symbol${0}:symbol`).position.setY(0);
    resourceManager.get(`slotContainer:reelContainer:reel${i}:symbol${2}:symbol`).position.setY(0);
    resourceManager.get(`slotContainer:reelContainer:reel${i}:symbol${0}:symbol`).visible = true;
    resourceManager.get(`slotContainer:reelContainer:reel${i}:symbol${2}:symbol`).visible = true;
  }
  //Clean up symbol animations
  gameController.symbolAnimator.cleanUp();
  timerManager.stop(gameController.cycleWinsDelayTimer);

  gameController.goldenBetButton.onSpin();

  gameController.shuffleLastSpin = false;
  gameController.canSlamStop = true;
  gameController.slamStopped = false;
  gameController.bonusSymbolsLanded = 0;
  gameController.bonusWWSymbolsLanded = 0;
  gameController.waitingForLandAnim = false;
  gameController.cyclingWins = false;
  gameController.bigWin._newSpin = true;
  //winlineAnimationController.skipAnimations();
  gameController.bigWin._newSpin = false;
  gameController.lastPayWinsData = undefined;
  gameController.spinComplete = false;
  gameController.spinHasWin = false;

  gameController.stoppedReels = [false, false, false, false, false];
  gameController.landedReels = [false, false, false, false, false];

  // gameController.winlineAnimator.skipAnimation();
  spinController.startSpin();
  gameController.setState_WaitingForServer();
  gameController.featurePrize = 0;
  gameController.reelsPrize = 0;
};

gameController.initNewGame = function () {
  gameController.gameRecovering = false;
  gameController.preFSReelPrize = 0;
  gameController.stateMachine.switchState('GAME_PLAYING');
  gameController.initNewSpin();
  if (resourceManager.getController('autoplayController').Enabled) {
    resourceManager
      .getController('inputOverlord')
      .setText('autoplayCancelButton', String(autoplayManager.getRemainingRounds()));
    resourceManager
      .getController('inputOverlord')
      .setText('autoplayCancelButton_portrait', String(autoplayManager.getRemainingRounds()));
  }
};

gameController.startGame = function () {
  gameController.justHadFreeSpins = false;
  gameController.initNewGame();

  const stakeController = resourceManager.getController('stakeController');
  let bpl = stakeController.BaseStake / stakeController.CurrentWinLineCount;

  gdk.startGame(
    {
      stake: stakeController.CurrentStake,
      numWinlines: stakeController.CurrentWinLineCount,
      bpl: bpl,
      metaData: {
        buyABonus: false,
        encore: gameData.encoreEnabled,
      },
    },
    function () {
      gdk.getNextGameOutcome(function () {});
    }
  );
};

gameController.setState_WaitingForServer = function (eventToLeave) {
  if (!gameController.inFreespins) {
    // Only monitor how long we are waiting for server if we arent in freespins
    gameController.stateMachine.switchState('WAITING_FOR_SERVER');
  }
  if (checkForDefined(eventToLeave)) {
    eventToLeave.leave();
  }
};

gameController.autoplayStarted = function (autoplayData) {
  resourceManager
    .getController('inputOverlord')
    .setText('autoplayCancelButton', String(autoplayManager.getRemainingRounds()));
  resourceManager
    .getController('inputOverlord')
    .setText('autoplayCancelButton_portrait', String(autoplayManager.getRemainingRounds()));
};

gameController.autoplayEnded = function (autoplayData) {
  //winlineManager.enableWinlinesTouch(true);
  // var button = resourceManager.get('buttonsContainer:autoplayGroupButtons:autoplayButton');
  resourceManager.getController('inputOverlord').setTranslatonPhrase('autoplayButton', 't_autoplay');
};

StateMachine.Create(gameController);

gameController.stateMachine.addState('WAITING_FOR_LOAD', function () {});

gameController.cancelAutoplay = function () {
  resourceManager.getController('autoplayController').cancel();
};

gameController.stateMachine.addState('WAITING_FOR_START', function () {
  if (gameController.phase.hold()) {
    if (!resourceManager.getController('autoplayController').LimitPopupOpen) {
      gameController.phase.step();
    }
  }

  if (gameController.phase.once()) {
    if (!autoplayManager.isAutoplayEnabled() && !gameController.shuffleLastSpin) {
      gameController.cyclingWins = true;
      timerManager.addTimeout(1000, gameController.cycleWins);
    }
  }

  if (gameController.phase.hold()) {
    // Waiting for player to do something
    if (autoplayManager.isAutoplayEnabled()) {
      if (autoplayManager.AP.getFields()['numberOfRounds'].currentValue !== autoplayManager.AP.roundsRemaining()) {
        resourceManager.getController('autoplayController').timeToNextAutoplay = 500; //dlConst.DELAY_BETWEEN_SPINS;
        gameController.phase.step();
      }
    }

    if (gameController.autoMode && gameController.firstGamePlayed) {
      gameController.phase.step();
    }
  }
  if (gameController.phase.timed(resourceManager.getController('autoplayController').timeToNextAutoplay)) {
  }
  if (gameController.phase.once()) {
    gameController.startGame();
    if (autoplayManager.AP.roundsRemaining() === 0) {
      // Last round, so cancel autoplays
      gameController.cancelAutoplay();
    }
  }
});

gameController.stateMachine.addState('SPIN_REELS_SPINNING', function () {
  clearInterval(this._logoInterval);
});

gameController.stateMachine.addState('WAITING_FOR_SERVER', function () {});

gameController.stateMachine.addState('PAYING_TO_WINNINGS', function () {
  if (gameController.phase.enter()) {
    // winMeter.meter.cancelCountUp();
    /*soundManager.play(gameData.countUpSound);
		var countTime = Math.min(1500);
		gameData.winningsMeter.countUp(gameController.winsTask.data.totalLineWinnings, countTime);
        gameData.winningsMeterPortraitAndMobile.countUp(gameController.winsTask.data.totalLineWinnings, countTime);*/
  }
  if (gameController.phase.hold()) {
    if (!gameData.winningsMeter.Props.isCounting) {
      // Finished counting
      if (!gameData.slotConfig.promotionActive) {
        resourceManager.get('winningsMeterLabel').visible = true;
      }
      gameController.unFadeSymbols();
      timerManager.addTimer(1000, undefined, gameController.onDelayShowWinningsComplete);
      gameController.stateMachine.switchState('DELAY_SHOW_WINNINGS');
    } else {
      if (!gameData.slotConfig.promotionActive) {
        resourceManager.get('winningsMeterLabel').visible = gameController.gameTime % 200 < 100;
      }
    }
  }

  if (gameController.phase.exit()) {
    if (!gameData.slotConfig.promotionActive) {
      resourceManager.get('winningsMeterLabel').visible = true;
    }
  }
});

gameController.stateMachine.addState('GAME_PLAYING', function () {
  if (gameController.phase.enter()) {
  }
});

gameController.stateMachine.addState('GAME_ENDED', function () {
  if (gameController.phase.once()) {
    gdk.endGame(function () {
      gameController.stateMachine.switchState('WAITING_FOR_START');
      gameController.baseSpin = true;
    });
  }
});

gameController.stateMachine.switchState('WAITING_FOR_LOAD');

gameController.update = function (delta, time) {
  gameController.stateMachine.update();
};

gameController.cycleWins = function (once, callback) {
  if (gameController.cyclingWins) {
    if (gameController.lastPayWinsData !== undefined && gameController.lastPayWinsData.winningLines !== undefined) {
      gameController.cyclingWinsIndex = 0;
      gameController.cycleWinTimer = timerManager.addTimer(500, undefined, function () {
        gameController.cycleWin();
      });
    }
  }
};

gameController.cycleWin = function () {
  let winningLinesExists;
  try {
    gameController.lastPayWinsData.winningLines;
    winningLinesExists = true;
  } catch (e) {
    winningLinesExists = false;
  }

  if (winningLinesExists) {
    const stakeController = resourceManager.getController('stakeController');
    gameController.symbolAnimating = true;
    const data = gameController.lastPayWinsData.winningLines[gameController.cyclingWinsIndex];
    let symbols = [];
    for (let i = 0; i < data.positions.length; ++i) {
      symbols.push({
        cell: { reel: data.positions[i].reel, row: data.positions[i].row },
        symbolId: data.symbol.ids[i],
      });
    }

    const canCelebrate = this.lastPayWinsData.totalLineWinnings > stakeController.BaseStake;

    // Dim symbols not in the current winning line
    gameController.slotMachine.clearDimSymbolIds();
    gameController.dimNoneWinningSymbols([data]);

    const lineDurations = gameController.winlineDisplay.animateWinline(
      data.winningLine,
      data.direction,
      data.winAmount,
      -1,
      false,
      true
    );

    gameController.backgroundSymAnim.playAnims(data, lineDurations);

    gameController.symbolAnimator.animateScalingSymbols(
      data.direction,
      symbols,
      lineDurations,
      gameController.slotMachine
    );

    musicManager.playRandomFromArray(gameController.winlineHighlightSounds);

    gameController.animating = true;

    timerManager.addTimer(1700, undefined, function () {
      gameController.animating = false;
      gameController.symbolAnimating = false;
      gameController.symbolAnimator.skip();
      gameController.cycleNextWin();
    });
  }
};

gameController.skip = function () {
  gameController.winSkipped = true;
  if (gameController.winAnimationDelayTimer !== undefined) {
    timerManager.stop(gameController.winAnimationDelayTimer);
    gameController.winAnimationDelayTimer = undefined;
    gameController.winlineAnimsDone();
  }
  gameController.winControllerMain.skipAnimations();
  gameController.winlineAnimator.skipAnimation();
};

gameController.cycleNextWin = function () {
  if (
    gameController.cyclingWins &&
    !gameController.symbolAnimating &&
    !gameController.animating &&
    gameController.lastPayWinsData &&
    gameController.lastPayWinsData.winningLines
  ) {
    ++gameController.cyclingWinsIndex;
    if (gameController.cyclingWinsIndex < gameController.lastPayWinsData.winningLines.length) {
      gameController.cycleWin();
    } else {
      gameController.cycleWins();
    }
  }
};

gameController.onLimitsPopupClosed = function () {
  soundManager.play(gameData.sounds.buttonPressed);
  gameController.stateMachine.switchState('GAME_ENDED');
};

// helper function to get the current stake based on game mode
// e.g. base game, buy a bonus
gameController.getCurrentModeStake = function (ignoreGoldenBetMultiplier) {
  let stake = 0;
  const stakeController = resourceManager.getController('stakeController');
  if (stakeController) {
    stake = stakeController.getCurrentStake('default');

    if (gameController.inBuyABonusNormal) {
      stake = stakeController.getCurrentStake('BONUS_BUY');
    }
    if (gameController.inBuyABonusExtra) {
      stake = stakeController.getCurrentStake('BONUS_BUY_XTRA');
    }

    // in golden bet the fireball values are based on the base stake so multiply down
    let goldenBetButton = resourceManager.get('goldenBetToggleButton');
    if (ignoreGoldenBetMultiplier && goldenBetButton !== undefined && goldenBetButton._flags.showGoldenBetActive) {
      stake = stake / 1.5;
    }
  }
  return stake;
};

gameController.onStakeChanged = function (stake) {
  const currentStake = gameData.stakes[gameData.currentStakeIndex];

  if (stake === undefined) {
    return;
  }

  if (currentStake !== stake && stake !== undefined) {
    gameData.currentStakeIndex = gameData.stakes.indexOf(stake);
    gameController.currentStake = stake;

    if (gameData.stakeMeter.value > 0) {
      soundManager.play('buttonPressed');
    }

    if (!gameData.ignoreResetWinningsMeterOnStakeChange) {
      gameData.winningsMeter.set(0);
    }
    gameData.ignoreResetWinningsMeterOnStakeChange = false;

    gameController.cyclingWins = false;
    gameController.lastPayWinsData = undefined;
    gameController.slotMachine.clearDimSymbolIds(0);
  }

  gameData.stakeMeter.set(stake);
  gdk.playerChangedStake(stake);
};

gameController.onGameComplete = function () {
  if (!gameData.slotConfig.promotionActive && !gameController.gameRecovering) {
    gameData.creditMeter.set(gameData.credit + gameController.totalWinnings);
  }

  const isBonusBuy = gameController.inBuyABonusNormal || gameController.inBuyABonusExtra;
  if (isBonusBuy) {
    persistence.setCurrentMode('BASIC');
    const stakeController = resourceManager.getController('stakeController');
    //stakeController.broadcastCurrentStake('default');

    let returnStake = gameController.bonusBuyStake;

    const stakeIndex = stakeController.Stakes.indexOf(returnStake);
    if (stakeIndex === -1) {
      // the bonus buy stake isnt in the BASIC stake
      // so we need to use the default
      // this is assuming default stake has been set correctly :( as everything appears to be in closures!!
      if (!gameController.currentNonBABStake) {
        returnStake = stakeController.BaseStake;
      } else {
        returnStake = gameController.currentNonBABStake;
      }
      gameData.ignoreResetWinningsMeterOnStakeChange = true;
    }

    gameController.currentNonBABStake = returnStake;
    stakeController.requestChangeStake(gameController.currentNonBABStake);
  }

  // Only reset the trail after a shuffle feature ends
  if (gameController.shuffleLastSpin) {
    gameController.multiplierTrail.onShuffleEndEvent();
  }

  // must do this here else symbols retain the buy a bonus values
  gameController.inBuyABonusNormal = false;
  gameController.inBuyABonusExtra = false;
  //gameData.creditMeter.set(gameData.credit + gameController.totalWinnings);
  gameController.setLogoIdle(true);

  musicManager.onGameEnd();

  gdk.endGame(function () {
    gameController.orbDisplay.stopAllOrbSparks();
    resourceManager.getController('autoplayController').checkLimits();
    // Check again in case we just cancelled autoplay
    if (autoplayManager.isAutoplayEnabled() === false) {
      resourceManager.getController('inputOverlord').setState('enabled');
      gameController.stateMachine.switchState('WAITING_FOR_START');
    } else {
      // Next game is AUTOPLAY
      gameController.stateMachine.switchState('WAITING_FOR_START');
    }
  });
};

gameController.doSlamStop = function () {
  if (gameData.reelsSpinning > 0) {
    gameController.slamStopped = true;
    // gameController.reelSpinSound = soundManager.stop('soa_reelspin_v1');

    gameController.reelsToSlam = [];
    for (let i = 0; i < gameController.longSpinReels.length; ++i) {
      if (!gameController.longSpinReels[i]) {
        gameController.reelsToSlam.push(i);
      } else {
        break;
      }
    }

    gameController.slotMachine.slamReels(gameController.reelsToSlam);

    // Light all orbs simultaneously for slammed reels
    for (let i = 0; i < gameData.numReels; i++) {
      gameController.onSpinHit(i);
    }
  }
};

gameController.determineBaseWinMusicLevel = function (winTask) {
  let winningLines = winTask.data.winningLines;
  for (let i = 0; i < winningLines.length; i++) {
    if (winningLines[i].symbol.ids.includes(7) || winningLines[i].symbol.ids.includes(6)) {
      return 4;
    } else if (winningLines[i].symbol.ids.includes(4) || winningLines[i].symbol.ids.includes(5)) {
      return 3;
    }
  }
  return 2;
};

gameController.doPayWins = function (winTask) {
  // Swap any mystery symbols for their symbols underneath if needed
  const symbolsInfo = resourceManager.getConfiguration().symbols;
  if (gameController.mysteryData !== undefined) {
    const newSym = gameController.mysteryData.symbol;
    for (let line = 0; line < winTask.data.winningLines.length; line++) {
      for (let sym = 0; sym < winTask.data.winningLines[line].symbol.ids.length; sym++) {
        if (winTask.data.winningLines[line].symbol.ids[sym] === symbolsInfo['Mystery'].ID) {
          winTask.data.winningLines[line].symbol.ids[sym] = newSym;
        }
      }
    }
  }

  gameController.winTask = winTask;
  gameController.winTask.join();

  if (!gameController.inShuffle) {
    // const stakeController = resourceManager.getController('stakeController');
    // const stake = stakeController.getCurrentStake('default');
  } else {
    gameController.totalWinnings += winTask.data.totalLineWinnings;
  }

  const stake = gameController.getCurrentModeStake();
  const batcher = resourceManager.getSharedPlugin('WinBatcherGroupedSymbolsEx');
  //const batches = batcher.batch(winTask.data, winTask.data.totalLineWinnings > stake);

  gameController.animWinsFinished = false;

  gameController.reelsPrize = winTask.data.totalLineWinnings;
  if (!gameController.inFreeSpins) {
    gameController.preFSReelPrize = gameController.reelsPrize;
  }

  gameController.lastPayWinsData = winTask.data;

  timerManager.addTimeout(1, function () {
    if (gameController.inShuffle) {
      messageBus.postImmediate('scaleMultiplerTrail', gameController.winTask);
    }

    gameController.animateWinlines();

    gameController.lastTotalLineWinnings = winTask.data.totalLineWinnings;
  });
};

gameController.animateWinlines = function () {
  musicManager.decreaseCurrentTuneVolume();

  const canCelebrate =
    gameController.winTask.data.totalLineWinnings > resourceManager.getController('stakeController').BaseStake;

  const sortedWinlines = gameController.winTask.data.winningLines.sort(
    (lineA, lineB) => lineA.symbol.value - lineB.symbol.value
  );

  const winlinesGroupedBySymbolId = [];
  sortedWinlines.forEach((line) => {
    if (winlinesGroupedBySymbolId[line.symbol.value] == null) {
      winlinesGroupedBySymbolId[line.symbol.value] = [];
    }
    winlinesGroupedBySymbolId[line.symbol.value].push(line);
  });

  const symbolsToAnimateAfterWinlines = [];
  if (canCelebrate) {
    sortedWinlines.forEach((line) => {
      if (symbolsToAnimateAfterWinlines[line.symbol.value] == null) {
        symbolsToAnimateAfterWinlines[line.symbol.value] = new Set();
      }
      line.positions.forEach((sym) => {
        symbolsToAnimateAfterWinlines[line.symbol.value].add(JSON.stringify(sym));
      });
    });
    symbolsToAnimateAfterWinlines.forEach((winGroup, index) => {
      if (winGroup != null) {
        // removing duplicate symbols!
        const uniqueSymbols = Array.from(winGroup).map((jsonSymbolData) => {
          const symbolData = JSON.parse(jsonSymbolData);
          return {
            cell: { reel: symbolData.reel, row: symbolData.row },
            symbolId: index,
          };
        });
        symbolsToAnimateAfterWinlines[index] = uniqueSymbols;
      }
    });
  }

  gameController.animateWinlinesBySymbolId(winlinesGroupedBySymbolId, symbolsToAnimateAfterWinlines, canCelebrate);
};

gameController.animateNextWinlinesBySymbolId = function (
  winlinesGroupedBySymbolId,
  symbolsToAnimateAfterWinlines,
  canCelebrate
) {
  winlinesGroupedBySymbolId.shift();
  symbolsToAnimateAfterWinlines.shift();
  gameController.animateWinlinesBySymbolId(winlinesGroupedBySymbolId, symbolsToAnimateAfterWinlines, canCelebrate);
};

gameController.animateWinlinesBySymbolId = function (
  winlinesGroupedBySymbolId,
  symbolsToAnimateAfterWinlines,
  canCelebrate
) {
  if (winlinesGroupedBySymbolId.length && !gameController.winlinesCancelled) {
    if (winlinesGroupedBySymbolId[0] == null) {
      winlinesGroupedBySymbolId.shift();
      symbolsToAnimateAfterWinlines.shift();
    }

    gameController.animateWinline(winlinesGroupedBySymbolId[0], canCelebrate, () => {
      if ((symbolsToAnimateAfterWinlines?.[0]?.length ?? 0) > 0) {
        // all winlines from that symbol id group has been presented
        // now we do symbol animations of all winning symbols

        gameController.slotMachine.clearDimSymbolIds();
        gameController.dimAllNonWinningSymbols(symbolsToAnimateAfterWinlines[0]);

        if (gameController.symbolAnimator.hasAnimation(symbolsToAnimateAfterWinlines[0][0].symbolId)) {
          const totalWinnings = gameController.winTask.data.totalLineWinnings;
          const stake = resourceManager.getController('stakeController').BaseStake;
          if (totalWinnings > 5 * stake) {
            musicManager.playRandomFromArray(gameController.winlineSoundsHi);
          } else if (totalWinnings > 3 * stake) {
            musicManager.playRandomFromArray(gameController.winlineSoundsMed);
          } else {
            musicManager.playRandomFromArray(gameController.winlineSoundsLow);
          }

          gameController.symbolAnimator.animateSymbols(
            symbolsToAnimateAfterWinlines[0],
            gameController.slotMachine,
            canCelebrate,
            false,
            () => {
              // then call back to continue to present the next group of winlines
              gameController.animateNextWinlinesBySymbolId(
                winlinesGroupedBySymbolId,
                symbolsToAnimateAfterWinlines,
                canCelebrate
              );
            },
            false
          );
        } else {
          if (gameController.winlinesCancelled) {
            gameController.winlinePreAnimsDone();
          } else {
            // no animation available so scale up and use bg
            const totalWinnings = gameController.winTask.data.totalLineWinnings;
            const stake = resourceManager.getController('stakeController').BaseStake;
            if (totalWinnings > 5 * stake) {
              musicManager.playRandomFromArray(gameController.winlineSoundsHi);
            } else if (totalWinnings > 3 * stake) {
              musicManager.playRandomFromArray(gameController.winlineSoundsMed);
            } else {
              musicManager.playRandomFromArray(gameController.winlineSoundsLow);
            }
            gameController.backgroundSymAnim.playAnimsAtSameTime(symbolsToAnimateAfterWinlines[0], () => {
              // then call back to continue to present the next group of winlines
              gameController.animateNextWinlinesBySymbolId(
                winlinesGroupedBySymbolId,
                symbolsToAnimateAfterWinlines,
                canCelebrate
              );
            });

            gameController.symbolAnimator.animateScalingSymbolsAtSameTime(
              symbolsToAnimateAfterWinlines[0],
              gameController.slotMachine
            );
          }
        }
      } else {
        if (gameController.winlinesCancelled) {
          gameController.winlinePreAnimsDone();
        } else {
          // then call back to continue to present the next group of winlines
          gameController.animateNextWinlinesBySymbolId(
            winlinesGroupedBySymbolId,
            symbolsToAnimateAfterWinlines,
            canCelebrate
          );
        }
      }
    });
  } else {
    gameController.winlinePreAnimsDone();
  }
};

gameController.animateWinline = function (data, canCelebrate, callback) {
  if (data != null && data.length && !gameController.winlinesCancelled) {
    let symbols = [];
    for (let i = 0; i < data[0].positions.length; i++) {
      symbols.push({
        cell: {
          reel: data[0].positions[i].reel,
          row: data[0].positions[i].row,
        },
        symbolId: data[0].symbol.ids[i],
      });
    }

    // Dim symbols not in the current winning line
    gameController.slotMachine.clearDimSymbolIds();
    gameController.dimNoneWinningSymbols([data[0]]);

    let multiplierFound = -1;
    let multiplierCell = undefined;

    for (let i = 0; i < symbols.length; i++) {
      if (symbols[i].symbolId === 11) {
        multiplierFound = 2;
        multiplierCell = symbols[i].cell;
      } else if (symbols[i].symbolId === 12) {
        multiplierFound = 3;
        multiplierCell = symbols[i].cell;
      } else if (symbols[i].symbolId === 13) {
        multiplierFound = 5;
        multiplierCell = symbols[i].cell;
      }
    }

    let megawildOnReel3 = false;
    if (multiplierCell) {
      if (multiplierCell.reel === 2) {
        megawildOnReel3 = true;
      }
    }

    musicManager.playRandomFromArray(gameController.winlineHighlightSounds);

    const lineDurations = gameController.winlineDisplay.animateWinline(
      data[0].winningLine,
      data[0].direction,
      data[0].winAmount,
      multiplierFound,
      megawildOnReel3
    );

    const winAmount = data[0].winAmount;

    gameController.backgroundSymAnim.playAnims(data[0], lineDurations, () => {
      data.shift();
      gameController.checkForMultiwildWinlineDelay(
        winAmount,
        multiplierCell,
        data,
        canCelebrate,
        multiplierFound,
        callback
      );
    });

    gameController.symbolAnimator.animateScalingSymbols(
      data[0].direction,
      symbols,
      lineDurations,
      gameController.slotMachine
    );
  } else {
    callback();
  }
};

gameController.checkForMultiwildWinlineDelay = function (
  winAmount,
  multiplierCell,
  data,
  canCelebrate,
  multiplierFound,
  callback
) {
  const self = this;
  if (multiplierFound === -1) {
    gameController.animateWinline(data, canCelebrate, callback);
  } else {
    gameData.winningsText.countUpWin(winAmount, 0.5, 0.25);

    let symId = -1;
    if (multiplierFound === 2) {
      symId = 11;
    } else if (multiplierFound === 3) {
      symId = 12;
    } else {
      symId = 13;
    }

    const multiplierOverlay = gameData.reels[multiplierCell.reel].getMegaWildOverlay(multiplierCell.row, symId);
    gsap.to(multiplierOverlay.scale, {
      x: 1.5,
      y: 1.5,
      duration: 0.1,
      yoyo: true,
      repeat: 7,
      ease: 'linear',
      onComplete: () => {
        multiplierOverlay.scale.set(1);
      },
    });

    timerManager.addTimeout(1000, function () {
      self.animateWinline(data, canCelebrate, callback);
    });
  }
};

gameController.getHighestSymbolId = function (symbols) {
  let highestId = 0;
  symbols.forEach((symbol) => {
    if (symbol.symbolId > highestId) {
      highestId = symbol.symbolId;
    }
  });
  return highestId;
};

gameController.dimAllNonWinningSymbols = function (symbols) {
  // dim none winning symbols
  const winningPositions = [];
  symbols.forEach((symbol) => {
    winningPositions.push(symbol.cell.reel * 5 + symbol.cell.row);
  });

  const symbolsToDim = [];
  for (let reel = 0; reel < 5; ++reel) {
    for (let row = 0; row < 4; ++row) {
      if (winningPositions.indexOf(reel * 5 + row) === -1) {
        symbolsToDim.push({ reel: reel, row: row });
      }
    }
  }

  gameController.slotMachine.dimSymbols(symbolsToDim, true, 0.3);
};

gameController.dimNoneWinningSymbols = function (winningLines) {
  // dim none winning symbols
  let winningPositions = [];
  for (let i = 0; i < winningLines.length; ++i) {
    let winningLine = winningLines[i];
    let positions = winningLine.positions;
    for (let j = 0; j < positions.length; ++j) {
      let cell = positions[j];
      winningPositions.push(cell.reel * 5 + cell.row);
    }
  }

  let symbolsToDim = [];
  for (let reel = 0; reel < 5; ++reel) {
    for (let row = 0; row < 4; ++row) {
      if (winningPositions.indexOf(reel * 5 + row) === -1) {
        symbolsToDim.push({ reel: reel, row: row });
      }
    }
  }

  gameController.slotMachine.dimSymbols(symbolsToDim, true, 0.3);
};

gameController.winlinePreAnimsDone = function () {
  gameController.animWinsFinished = true;
  gameController.slotMachine.dimAllSymbols(true, 0);

  let isBigWin = gameController.bigWin.checkBigWin(gameController.reelsPrize);

  if (gameController.inShuffle || (!isBigWin && !gameController.lastPayWinsData.isCapped)) {
    gameData.winningsText.setText(Math.floor(gameController.lastPayWinsData.totalLineWinnings));
    gameData.winningsText.show(true, gameController.lastPayWinsData.totalLineWinnings);
    gameData.winningsText.animate(false, false, gameController.inShuffle);
    // if (gameController.currentMultiplier > 4) {
    //   soundManager.play('soa_feature_total_multiply_hi_v1');
    // } else if (gameController.currentMultiplier > 1) {
    //   soundManager.play('soa_feature_total_multiply_lo_v1');
    // }
  }

  if (!gameController.inShuffle && isBigWin) {
    gameController.bigWin.start(
      gameController.reelsPrize,
      function () {
        timerManager.addTimeout(500, () => {
          musicManager.resumeBaseMusic();
        });
        gameController.winlineAnimsDone();
      },
      gameController.lastPayWinsData.isCapped
    );
  } else {
    gameController.winlineAnimsDone();
  }
  // gameController.bigWin.start(
  // gameController.reelsPrize,
  // function () {
  //   if (!gameController.inShuffle && gameController.bigWin.checkBigWin(gameController.reelsPrize)) {
  //     gameController.startGameTune();
  //   }
  //   gameController.winlineAnimsDone();
  // },
  // false,
  // gameController.inShuffle,
  // undefined,
  // undefined,
  // undefined,
  // false
  // );
};

gameController.winlineAnimsDone = function () {
  const isBigWin = gameController.bigWin.checkBigWin(gameController.reelsPrize);
  if (!(!gameController.inShuffle && isBigWin)) {
    musicManager.increaseCurrentTuneVolume();
  }

  const currentMultiplier = gameController.currentMultiplier - 1;
  gameController.slotMachine.clearDimSymbolIds();
  // Add delay during shuffle to allow the full win animation sequence to complete
  timerManager.addTimer(
    gameController.inShuffle ? 3500 : 0,
    function () {},
    function () {
      //gameController.winlineAnimationController.clearWinlines();
      if (gameController.inShuffle) {
        // Animate trail, then request next shuffle
        gameController.animateTrailAfterWins(function () {
          gameController.endWinTask();
          if (!gameController.shuffler._lastShuffle) {
            gdk.getNextGameOutcome(function () {});
          }
        });
      } else {
        gameController.endWinTask();
      }
    }
  );
};

gameController.endWinTask = function () {
  gameController.winlinesCancelled = false;
  gameController.winTask.leave();
  gameController.winTask = undefined;
};

/**
 * Animate the multiplier trail after win displays complete.
 * @param {function} callback
 */
gameController.animateTrailAfterWins = function (callback) {
  const isLastShuffle = gameController.shuffler._lastShuffle;

  if (isLastShuffle) {
    // Last shuffle - don't move trail (feature is ending)
    if (callback) {
      callback();
    }
  } else {
    // Not last shuffle - move trail up to prepare for next shuffle
    gameController.multiplierTrail.moveUpTrail(function () {
      if (callback) {
        callback();
      }
    });
  }
};

gameController.skipWinAnimations = function () {
  //blackLotusWinlineAnimator.darkenReels(true);
  gameController.bigWin.skip(gameController.winlineAnimsDone);
};

gameController.isAnimatingWins = function () {
  return gameController.winTask !== undefined;
};

gameController.skipWin = function () {
  // _skipWin = true;
  if (gameController.winAnimationDelayTimer !== undefined) {
    timerManager.stop(gameController.winAnimationDelayTimer);
    gameController.winAnimationDelayTimer = undefined;
    gameController.winlineAnimsDone();
  }
  gameController.winControllerMain.skipAnimations();
  // gameController.winlineAnimator.skipAnimation();
};

gameController.freespinsComplete = function (value) {
  gameController.reelsPrize = gameController.preFSReelPrize;
  gameController.featurePrize = value;
  gameController.stateMachine.switchState('IDLE');
};

gameController.onFreespinsStart = function () {
  autoplayManager.stopAutoplay();
  gameController.inFreeSpins = true;
};

gameController.onFreespinsEnd = function () {
  gameController.inFreeSpins = false;
};

gameController.onFeatureStart = function (task) {
  //this._featureStartTask = task;
  //this._featureStartTask.join();
};

gameController.recoverGame = function (task) {
  gameController.gameRecovering = true;
  resourceManager.get('goldenBetToggleButton').visible = false;
  resourceManager.get('helpPageScroll').close();
  if (gdk.serverParser._inReplayMode) {
    gameController.gameReplaying = true;
  }

  if (task.data.metaData === 'buyABonus' && task.data.metaValue) {
    gameController.inBuyABonusNormal = true;
    gameController.bonusBuyStake = gameData.recoveryStake;
  } else if (task.data.metaData === 'buyABonusXtra' && task.data.metaValue) {
    gameController.inBuyABonusExtra = true;
    gameController.bonusBuyStake = gameData.recoveryStake;
  } else if (task.data.metaData === 'encore' && gameData.encoreEnabled !== task.data.metaValue) {
    // Clear any encore effects and stop them appearing again
    gameData.encoreEnabled = task.data.metaValue;

    resourceManager.get('helpPageScroll').close();

    if (gdk.getPlatformAllowsUpstake()) {
      gameController.goldenBetReplayOn.visible = gameData.encoreEnabled;
      gameController.goldenBetReplayOff.visible = !gameData.encoreEnabled;

      // Put button in the right state if not already true
      var encoreButtonLB = resourceManager.get('goldenBetToggleButton');

      if (encoreButtonLB._flags.showGoldenBetActive !== gameData.encoreEnabled) {
        encoreButtonLB.setRecovery();
      }
    }
  }

  if (task.data.metaData !== 'buyABonusXtra') {
    gameController.initNewGame();
  }
};

gameController.onAbortGame = function () {
  gameController.slotMachine.abortSpin();
  Loader.setStartingSymbols();
};

gameController.replayComplete = function () {
  gameController.gameReplaying = false;
  if (!gameController.shuffleLastSpin) {
    gameController.cyclingWins = true;
    timerManager.addTimeout(1000, gameController.cycleWins);
  }
};

gameController.onOrientationChange = function () {};

gameController.onShuffleStartEvent = function () {
  gameController.shuffleStake = gameController.currentStake;
  gameController.inShuffle = true;
  soundManager.stop(gameController.idleTuneId);
  soundManager.stop(gameController.spinTuneId);
  gameController.idleThemePlaying = false;
  gameController.spinThemePlaying = false;
  gameController.cancelAutoplay();
};

gameController.onShuffleEndEvent = function (task) {
  gameController.inShuffle = false;
  gameController.shuffleLastSpin = true;

  if (gameController.bigWin.checkBigWin(task.data.shuffleWinnings)) {
    musicManager.onFeatureEnd();
    task.join();
    gameController.bigWin.start(
      task.data.shuffleWinnings,
      function () {
        gameController.shuffler.backToBaseGame();
        timerManager.addTimeout(500, function () {
          task.leave();
        });
      },
      gameController.lastPayWinsData.isCapped
    );
  }

  //if (gameController.shuffleStake) {
  //  const stakeController = resourceManager.getController('stakeController');
  //  stakeController.requestChangeStake(gameController.shuffleStake);
  //  gameController.shuffleStake = 0;
  //}
};

gameController.displayStakeChangePersistenceMessage = function () {
  let panel = resourceManager.get('stakeChangeContainer');
  panel.visible = true;
  panel.alpha = 1;

  if (gameController.stakeChangeAnim !== undefined) {
    gameController.stakeChangeAnim.kill();
  }
  gameController.stakeChangeAnim = gsap.to(panel, {
    delay: 3,
    duration: 1.0,
    alpha: 0,
    ease: 'none',
    onComplete: () => {
      panel.visible = false;
      panel.alpha = 1;
    },
  });
};

gameController.hideStakeChangePersistenceMessage = function () {
  if (gameController.stakeChangeAnim !== undefined) {
    gameController.stakeChangeAnim.kill();
    gameController.stakeChangeAnim = undefined;
  }
  let panel = resourceManager.get('stakeChangeContainer');
  if (panel) {
    panel.visible = false;
    panel.alpha = 1;
  }
};

gameController.onShuffleDataEvent = function (task) {
  gameController.currentMultiplier = task.data.multiplier;
};

gameController.onShuffleEndEventDead = function (task) {
  gameController.currentMultiplier = 1;
};

gameController.onMysterySymbolData = function (task) {
  gameController.mysteryData = task.data.mysteryData;
};

// Take a snapshot of current persistence data for a stake
gameController.takeStakeSnapshot = function (stake, mode) {
  const snapshotMode = mode || persistence.currentMode;
  gameController.stakeSnapshots[stake] = {
    mode: snapshotMode,
    data: persistence.getData(stake, snapshotMode),
  };
  console.log('take stake snapshot', stake, snapshotMode, gameController.stakeSnapshots[stake].data);
};

// Check if current data differs from snapshot
gameController.hasStakeDataChanged = function (stake) {
  const snapshot = gameController.stakeSnapshots[stake];
  if (!snapshot) return false;

  const currentData = persistence.getData(stake, snapshot.mode);
  console.log('has stake changed persistence =', currentData);
  // get changes object - null if no changes
  const changes = persistence.getDifferencesBetween2Objects(snapshot.data, currentData);
  const hasChanged = changes !== null;
  return hasChanged;
};

// Clear the snapshot
gameController.clearStakeSnapshot = function (stake) {
  delete gameController.stakeSnapshots[stake];
};

gameController.persistenceStakeChanged = function (data) {
  const newStake = data.stake;
  const oldStake = gameController.previousStake;
  const newMode = persistence.currentMode;
  const oldMode = gameController.previousMode;

  // Has the stake or mode really changed?
  if (oldStake !== newStake || oldMode !== newMode) {
    // Check if the stake we're LEAVING had changes since we started playing on that stake
    if (oldStake !== undefined && gameController.hasStakeDataChanged(oldStake) && gameController.firstGamePlayed) {
      gameController.showStakeChangeMessage = true; // Will check this when closing stake change panel
      gameController.clearStakeSnapshot(oldStake);
    }
    // Take a snapshot for the new stake/mode and remember them
    gameController.takeStakeSnapshot(newStake, newMode);
    gameController.previousStake = newStake;
    gameController.previousMode = newMode;
  }
};

gameController.winSkipPressed = function () {
  gameController.winlinesCancelled = true;
  gameController.winlineDisplay.cancelWinlines();
  //gameController.backgroundSymAnim.stopAnims();
  gameController.symbolAnimator.skip();
};

gameController.playLogoAnim = function () {
  gameController.logoAnim.gotoAndPlay(0);
};

gameController.startLogoAnimLoop = () => {
  if (gameController.logoInterval) clearInterval(gameController.logoInterval);

  gameController.logoInterval = setInterval(() => {
    if (document.visibilityState === 'visible' && gameController.idle) {
      gameController.playLogoAnim();
    }
  }, 5000);
};

gameController.stopLogoAnimLoop = () => {
  if (gameController.logoInterval) {
    clearInterval(gameController.logoInterval);
    gameController.logoInterval = null;
  }
};

gameController.setLogoIdle = (value) => {
  gameController.idle = value;
  if (gameController.idle) {
    gameController.startLogoAnimLoop();
  } else {
    gameController.stopLogoAnimLoop();
  }
};

gameController.onPreviousGameMode = (data) => {
  if (data.encore && gdk.getPlatformAllowsUpstake()) {
    const encoreButtonLB = resourceManager.get('goldenBetToggleButton');
    encoreButtonLB.setRecovery();
  }
};

gameController.onGameSkipped = function (stakeInfo) {
  if (gameData.recoveryMode === 'GOLDENBET_BUY' || !gameData.recoveryMode) {
    // we dont need to worry about this for GOLDENBET or normal
  } else {
    // we make the meter show the correct stake on a restore, but nothing seems to set the stake controller up correctly if you press skip
    // so we have a new message and we do that here
    // ideally this should be in the libs somewhere!!

    const stakeController = resourceManager.getController('stakeController');

    // now we can have bonus buys on different stakes compared to normal
    // os 1st lets make sure the stake is valid for BASIC
    const stakeIndex = stakeController.Stakes.indexOf(stakeInfo.baseStake);
    if (stakeIndex === -1) {
      // This is a bit of a hack, if the 'skip' button is pressed on recovery and the
      // stake played during a bought bonus is not in the list of stakes, BaseStake
      // is undefined here
      if (stakeController.BaseStake) {
        stakeInfo.baseStake = stakeController.BaseStake;
      } else {
        stakeInfo.baseStake = stakeController.Stakes[0];
      }
      gameData.ignoreResetWinningsMeterOnStakeChange = true;
    }

    stakeController.requestChangeStake(stakeInfo.baseStake);

    // trust me bro!
    gameData.stakeMeter.set(stakeInfo.baseStake);
  }
};

function globalHelperGetBaseStake() {
  return resourceManager.getController('stakeController').getBaseStake();
}

Reflex.addToUpdate(gameController.update);
messageBus.subscribe('spinner:SpinEvent', gameController.doSpin);
messageBus.subscribe('autoplay:started', gameController.autoplayStarted);
messageBus.subscribe('autoplay:ended', gameController.autoplayEnded);
messageBus.subscribe('stake:stakeChanged', gameController.onStakeChanged);
messageBus.subscribe('common:RecoverGame', gameController.recoverGame);
messageBus.subscribe('common:GameCompleteEvent', gameController.onGameComplete);
messageBus.subscribe('spinner:WinningLinesEvent', gameController.doPayWins);
messageBus.subscribe('game:FeatureAnnounceEvent', gameController.onFeatureStart);
messageBus.subscribe('spinner:FreeSpinsStartEvent', gameController.onFreespinsStart);
messageBus.subscribe('spinner:FreeSpinsEndEventDead', gameController.onFreespinsEnd);
messageBus.subscribe('spinner:FreeSpinsEndEventDead', gameController.onFreespinsEnd);
messageBus.subscribe('common:AbortGame', gameController.onAbortGame);
messageBus.subscribe('platform:ReplayComplete', gameController.replayComplete);
messageBus.subscribe('spinner:ShuffleStartEvent', gameController.onShuffleStartEvent);
messageBus.subscribe('spinner:ShuffleEndEvent', gameController.onShuffleEndEvent);
messageBus.subscribe('spinner:ShuffleEndEventDead', gameController.onShuffleEndEventDead);
Reflex.registerEventHandler('orientationChange', gameController.onOrientationChange);
messageBus.subscribe('spinner:ShuffleDataEvent', gameController.onShuffleDataEvent);
messageBus.subscribe('spinner:GameConfigEvent', gameController.gameFullyLoaded);
messageBus.subscribe('sidewinder:MysteryDataEvent', gameController.onMysterySymbolData);
messageBus.subscribe('persistence:stakeChanged', gameController.persistenceStakeChanged);
messageBus.subscribe('restore:previousGameMode', gameController.onPreviousGameMode);
messageBus.subscribe('common:GameSkipped', gameController.onGameSkipped);
